import React, { Component } from 'react'
import FormMixin from 'containers/shared/FormMixin'
import { connect } from 'react-redux'
import Card from '@material-ui/core/Card'
import Typography from '@material-ui/core/Typography'
import { NominationActions }       from 'actionsets/index'
import { withRouter }              from 'react-router'
import StyleSheet from 'styles/index'
import {FormattedMessage} from 'react-intl'

export class ExpressInterestForm extends FormMixin(Component){

  constructor(props){
    super(props)
    this.state = {
      params: {},
    }
    this.onSaveRoute = null
    NominationActions.bindActions(this)
  }

  static defaultProps = {
    submitRef: () => {}
  }

  componentDidMount(){
    this.props.submitRef(() => this.saveAction(this.updatedFormObject))
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.sizeOf !== prevState.sizeOf) {
      this.setAttribute(prevState.sizeOf, undefined)
    }
  }

  get formObject(){
    return { dealSheetId: this.props.dealSheet.id }
  }

  get createMode(){
    return true
  }

  get formObjectName(){
    return 'Expression of Interest'
  }

  get numberOfTokens(){
    const size = parseFloat(this.attribute('size')) || 0
    const privateRate = parseFloat(this.props.dealSheet.preSaleRate)
    const count = size * privateRate
    return count
  }

  get requestName() {
    return this.props.dealSheet.typeOfIssuance === 'product' ? 'quote' : 'allocation'
  }

  DialogNumberField = (props) => {
    const { LargeNumberField } = this
    return (
       <LargeNumberField {...props}
        inputProps={{className: fieldStyles.input, min: 100000, step: 10000}}
        InputLabelProps={{className: fieldStyles.inputLabel}}/>
    )
  }

  render = () => {
    if (!this.props.dealSheet.id)
      return false
    const sizeOf = this.props.dealSheet.typeOfIssuance === 'product' ? 'amount' : 'value'
    const unit = sizeOf === 'value' ? this.props.dealSheet.currency.code : (this.props.dealSheet.ticker || 'units')
    const { DialogNumberField } = this
    return (
      <Card className={styles.root}>
        <Typography className={styles.body}>
          <FormattedMessage id="deal.actions.request_allocation.instructions" values={{unit}} />
        </Typography>
        <br/>
        <DialogNumberField
          label={<FormattedMessage id="deal.actions.request_allocation.amount_label" values={{unit}} />}
          attribute={sizeOf}
        />
      </Card>
    )
  }
}

const fieldStyles = StyleSheet({
  input: {
    fontSize: '15px',
    fontWeight: '500'
  },
  inputLabel: {
    fontSize: '12px',
    fontWeight: 'normal'
  }
})

const styles = StyleSheet({
  root: {
    marginLeft: 0,
    marginRight: 0
  },
  body: {
    fontSize: '14px',
    fontWeight: 'bold'
  },
  subHeading: {
    fontSize: '18px',
    fontWeight: 'bold',
    marginTop: '58px'
  },
  footer: {
    fontSize: '13px',
    fontWeight: 'bold',
    marginTop: '26px'
  },
  label: {
    width: '60%',
    paddingLeft: 0,
    paddingRight: 0,
    fontSize: '14px',
    fontWeight: 'bold',
    borderBottom: 'solid 1px #586c7b'
  },
  value: {
    paddingLeft: 0,
    paddingRight: 0,
    fontSize: '14px',
    fontWeight: 'bold',
    borderBottom: 'solid 1px #586c7b',
    '&:last-child': {
      paddingRight: 0
    }
  }
}, {classNamePrefix: 'ExpressInterestForm-'})

export default connect(({nominations, dealSheets: { dealSheet }}) => {
  return {...nominations, dealSheet}
})(withRouter(ExpressInterestForm))